import React from 'react'
import styled from 'styled-components';

const Titulo = styled.p`
    color: ${({ theme }) => theme.tituloFiltro};
    font-weight: 300;
    margin-left: .25rem;
    margin-bottom: .5rem;
    margin-top: .5rem;
`

const TituloFiltro = ({ children, faIcon, className = "" }) => <>
    {faIcon && <i className={faIcon + ' mr-2' }></i>}
    <Titulo className={className}>{children}</Titulo>
</>
export default TituloFiltro